package com.milta.core.localization.translations.bg

import com.milta.core.localization.RouteCreationStrings

internal val RouteCreation = RouteCreationStrings(
    newRouteTitle = "Нов маршрут",
    stepDeliveries = "Доставки",
    stepDrivers = "Шофьори",
    stepDistribution = "Разпределение",
    deliveriesSummary = "%1 доставки · %2 пратки",
    deliveriesSummaryOne = "1 доставка · %1 пратки",
    toFixCount = "%1 за коригиране",
    allAddressesCorrect = "Всички адреси са правилни",
    filterAll = "Всички %1",
    filterToFix = "За коригиране %1",
    fixAddressesToContinue = "Коригирайте %1 адреса, за да продължите",
    fixOneAddressToContinue = "Коригирайте 1 адрес, за да продължите",
    continueWithDeliveries = "Продължи · %1 доставки",
    continueWithOneDelivery = "Продължи · 1 доставка",
    chooseAtLeastOneDriver = "Изберете поне един шофьор",
    reasonMissingHouseNumber = "Липсва номер на улицата",
    reasonNotFound = "Адресът не е намерен",
    reasonUnverified = "Проверката не е възможна, опитайте отново",
    missingHouseNumberExample = "Липсва номер на улицата. Пример: %1",
    notFoundHelp = "Адресът не е намерен. Проверете улицата, номера и пощенския код.",
    unverifiedHelp = "Адресът не можа да бъде проверен в момента. Опитайте отново след малко.",
    addToExistingHint = "Добавят се към %1 доставки, които вече са в списъка.",
    importFileAction = "Импортиране на файл",
    importFileHint = "Excel (.xlsx, .xls), CSV или PDF",
    manualEntryAction = "Ръчно въвеждане",
    manualEntryHint = "Име, адрес, телефон, краен час",
    addDeliveryTitle = "Добавяне на доставка",
    deleteDelivery = "Изтриване на доставката",
    addedFileAnalysing = "Анализ на %1…",
    addedFileFailed = "Импортът на %1 не беше успешен. Не е добавена доставка.",
    errorAddressesToFix = "Някои адреси не са потвърдени: коригирайте ги в списъка „За коригиране“.",
    errorAddressesCheckRetry = "Проверката на адресите не завърши. Опитайте отново след малко.",
    errorBatchAlreadyDispatched = "Това разпределение вече е изпратено на шофьорите.",
    editDeliveryTitle = "Редактиране на доставката",
    zoneLabel = "Зона %1",
    workloadBalanced = "Работното време е балансирано между шофьорите",
    workloadGap = "Разлика в работното време между шофьорите: %1",
    importAddedFromScan = "%1 доставки добавени от сканирането",
    importAddedOneFromScan = "1 доставка добавена от сканирането",
    importAddedFromPdf = "%1 доставки добавени от PDF файла",
    importAddedOneFromPdf = "1 доставка добавена от PDF файла",
    importAddedFromSpreadsheet = "%1 доставки добавени от Excel файла",
    importAddedOneFromSpreadsheet = "1 доставка добавена от Excel файла",
    importAddedToFixSuffix = ", от които %1 за коригиране",
    deliverySearchOpenAction = "Търсене на доставка",
    deliverySearchCount = "%1 от %2",
    deliverySearchCountToFix = "%1 от %2 за коригиране",
    deliverySearchEmptyTitle = "Няма съвпадащи доставки",
    deliverySearchEmptyToFixHint = "Няма съвпадащи доставки за коригиране. Опитайте в „Всички“.",
)
